import { BaseQueryApi, FetchArgs, createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { logOut, selectAccessToken, setCredentials } from '../../features/auth/authSlice'
import { RootState } from '../store';

const baseQuery = fetchBaseQuery({
    // baseUrl: "/api/",
    // baseUrl: "https://localhost:44378/api/",
    baseUrl: process.env.REACT_APP_BASE_URL,

    credentials: 'include',
    prepareHeaders: (headers, { getState }) => {
        const storedToken = localStorage.getItem('accessToken');
        const token = storedToken || (getState as () => RootState)().auth.accessToken;

        if (token) {
            headers.set("Authorization", `Bearer ${token}`);
        }
        return headers;
    },
});

const baseQueryWithReauth = async (args: string | FetchArgs, api: BaseQueryApi, extraOptions: {}) => {
    let result = await baseQuery(args, api, extraOptions);

    const state = api.getState();

    if (result?.error?.status === 401) {
        // send refresh token to get new access token 
        const storedToken = localStorage.getItem('refreshToken');
        const refreshResult = await baseQuery(
            { url: `/Account/refresh-token/${storedToken || (state as any)?.auth?.refreshToken || (api.getState() as RootState)?.auth?.refreshToken}`, method: 'POST', responseHandler: 'text', },
            api,
            extraOptions
        );

        if (refreshResult?.data) {
            api.dispatch(
                setCredentials({
                    user: (api.getState() as RootState)?.auth?.user || (state as any)?.auth?.user || localStorage.getItem('user'),
                    refreshToken: (api.getState() as RootState)?.auth?.refreshToken || (state as any)?.auth?.refreshToken || localStorage.getItem('refreshToken'),
                    accessToken: refreshResult?.data,
                    expires: (api.getState() as RootState)?.auth?.expires || (state as any)?.auth?.expires || localStorage.getItem('expires')
                })
            );

            // retry the original query with new access token 
            result = await baseQuery(args, api, extraOptions);
        } else {
            alert('An error occurred. Please login again.');
            api.dispatch(logOut());
            window.location.href = '/';
        }
    }
    return result;
};
export const apiSlice = createApi({
    // baseQuery: async (
    //     args: string | FetchArgs,
    //     api: BaseQueryApi,
    //     extraOptions: {}
    // ) => {
    //     //check token expire time
    //     return await baseQueryWithReauth(args, api, extraOptions)
    // },
    baseQuery: baseQueryWithReauth,
    endpoints: builder => ({})
})

export const blobExcelOption: FetchArgs = {
    url: "",
    method: "GET",
    responseHandler: (response) =>
        response.blob().then((blob) => URL.createObjectURL(blob)),
    cache: "no-cache",
};